import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { BODY_STATES } from '../../constants';
import { NoSuggestionsBody } from '../NoSuggestionsBody';
import { RecentSearchBody } from '../RecentSearchBody';
import { SearchLoading } from '../SearchLoading';
import { SearchQuerySuggestionsBody } from '../SearchQuerySuggestionsBody';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchBodyFactory(_ref) {
  let {
    type,
    searchQuerySuggestionsBodyProps,
    searchLoadingProps,
    recentSearchBodyProps,
    noSuggestionsBodyProps
  } = _ref;
  switch (type) {
    case BODY_STATES.LOADING:
      return /*#__PURE__*/_jsx(SearchLoading, _objectSpread({}, searchLoadingProps));
    case BODY_STATES.SEARCH_RESULTS:
      return /*#__PURE__*/_jsx(SearchQuerySuggestionsBody, _objectSpread({}, searchQuerySuggestionsBodyProps));
    case BODY_STATES.RECENT_SEARCHES:
      return /*#__PURE__*/_jsx(RecentSearchBody, _objectSpread({}, recentSearchBodyProps));
    case BODY_STATES.NO_SUGGESTIONS:
    case BODY_STATES.API_FAILURE:
      return /*#__PURE__*/_jsx(NoSuggestionsBody, _objectSpread({}, noSuggestionsBodyProps));
    case BODY_STATES.EMPTY_STATE:
    case BODY_STATES.NO_BODY:
    default:
      return null;
  }
}